import { Typography } from "../../../../../../shared/frontend/ui";
import React from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../../app/auth/useAuth";
import { useI18n } from "../../app/i18n/useI18n";
import { NavCardGrid } from "../../components/NavCardGrid";
import { LockedFeaturePage } from "../../components/LockedFeaturePage";
import { filterSettingsItems,settingsCapabilityByGroupKey,settingsCatalogGroups,settingsGroupCapabilityEnabled } from "./settingsCatalog";
import { useSettingsVisibilityContext } from "./useSettingsVisibilityContext";

export function SettingsGroupPage() {
  const { groupKey } = useParams<{ groupKey: string }>();
  const auth = useAuth();
  const { text } = useI18n();

  const requiredGroupCapability = groupKey ? settingsCapabilityByGroupKey[groupKey] : null;
  const group = settingsCatalogGroups.find((g) => g.key === groupKey);

  // Steht vor den Abbruch-Zweigen: hinter einem `return` aufgerufen, liefe der Hook nicht in jeder
  // Renderrunde, und React verlöre die Reihenfolge (rules-of-hooks). Ein fehlender Bereich ergibt
  // hier eine leere Liste; angezeigt wird sie ohnehin nur, wenn es ihn gibt.
  const visibility = useSettingsVisibilityContext();
  const isOwnerOrAdmin = visibility.isOwnerOrAdmin === true;
  const items = React.useMemo(() => {
    return filterSettingsItems(group?.items, visibility).map((item) => ({
      titleKey: item.titleKey,
      descriptionKey: item.descriptionKey,
      iconKey: item.iconKey,
      path: item.path,
      capabilityKey: item.capabilityKey ?? requiredGroupCapability ?? undefined
    }));
  }, [group?.items, visibility, requiredGroupCapability]);

  if (requiredGroupCapability && groupKey && !settingsGroupCapabilityEnabled(groupKey, auth.info) && !isOwnerOrAdmin) {
    return <LockedFeaturePage capabilityKey={requiredGroupCapability} />;
  }

  if (!group) {
    return (
      <div>
        <Typography.Text type="danger">{text("Group not found")}</Typography.Text>
      </div>
    );
  }

  // Ohne erlaubte Seite gibt es die Gruppe für diesen Benutzer nicht.
  if (items.length === 0) {
    return (
      <div>
        <Typography.Text type="danger">{text("Group not available")}</Typography.Text>
      </div>
    );
  }

  return (
    <NavCardGrid title={text(group.titleKey)} items={items} text={text} />
  );
}

